<template>
  <div
    :class="{
      'group bg-bgr-secondary hover:bg-bgr-secondary rounded-xl px-4 py-3': framed,
    }"
  >
    <label :class="['relative flex gap-3', { 'cursor-pointer': !readonly }]" :for="id">
      <input
        :id
        v-model="inputValue"
        :class="[
          'peer relative aspect-square size-5 shrink-0 cursor-pointer appearance-none rounded-full border transition-all duration-300',
          'bg-radio-bgr-default border-radio-bdr-default group-hover:border-radio-bdr-hover',
          'disabled:border-radio-bdr-disabled! disabled:bg-radio-bgr-disabled! disabled:cursor-default',
          {
            'checked:border-radio-bgr-active checked:bg-radio-bgr-checked': isChecked,
            'bg-radio-bgr-critical! border-radio-bdr-critical! group-hover:border-radio-bdr-critical-hover!': error,
          },
        ]"
        :disabled="readonly"
        :indeterminate="indeterminate"
        :value
        type="radio"
      />
      <div
        v-show="isChecked"
        :class="[
          'absolute inset-1.5 size-2 rounded-full transition duration-200',
          error ? 'bg-radio-fgr-critical' : 'bg-radio-fgr-checked',
        ]"
      />
      <div v-if="slots.default" class="text-body-default">
        <slot />
      </div>
    </label>
  </div>
</template>

<script setup lang="ts">
  const id = `radio-${useId()}`;
  const slots = defineSlots();

  const props = withDefaults(
    defineProps<{
      readonly?: boolean;
      indeterminate?: boolean;
      error?: string;
      framed?: boolean;
      value?: string | boolean | number;
    }>(),
    {
      readonly: false,
      indeterminate: false,
      error: "",
      framed: false,
      value: undefined,
    }
  );

  const inputValue = defineModel<string | boolean | number>({
    required: true,
  });

  const isChecked = computed(() => {
    return inputValue.value === props.value;
  });
</script>
